import * as React from 'react';
import EmbeddedPowerBIReport from '../../../Reporting';
import { useEffect } from 'react';
import LumenLoader from '../../../Loader';

interface MonthlySummaryProps {
    productLineCode?: string;
}

const PremiumChart: React.FunctionComponent<MonthlySummaryProps> = (props) => {
    const { productLineCode } = props;
    const PRODUCTION_BOUND_POLICIES_ID_CP = 'accd60ed-a74f-49a6-bc92-2a6e21fc525c';
    const PRODUCTION_BOUND_POLICIES_ID_GL = '012fb744-10b8-4726-822b-8adf50555128';
    const PRODUCTION_BOUND_POLICIES_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';
    const PRODUCTION_BOUND_POLICIES_PAGENAME = '548cdcf058aa590ab88b';

    const [delaying, setDelaying] = React.useState(false);

    useEffect(() => {
        if (delaying) {
            setTimeout(() => {
                setDelaying(false);
            }, 8500);
        }
    }, []);

    if (delaying) {
        return <LumenLoader fillHeight={'100%'} />;
    }

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={
                    productLineCode === 'COMMERCIAL_PROPERTY'
                        ? PRODUCTION_BOUND_POLICIES_ID_CP
                        : PRODUCTION_BOUND_POLICIES_ID_GL
                }
                workspaceId={PRODUCTION_BOUND_POLICIES_WORKSPACE_ID}
                height={'100%'}
                hidePageNav
                hideFilters
                pageName={PRODUCTION_BOUND_POLICIES_PAGENAME}
                hideReportBorder
            />
        </>
    );
};

export default PremiumChart;
